import { Component } from "@angular/core";

@Component({
  templateUrl: "./test-page.template.html"
})
export class TestPageComponent {}
